import { Component, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { ToastComponent } from '../../shared/toast/toast.component';
import { setClassInvalid } from '../../shared/functions';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-forgot-password-form',
  templateUrl: './forgot-password-form.component.html',
  standalone: false
})
export class ForgotPasswordFormComponent {
  private userService = inject(UserService);
  private formBuilder = inject(UntypedFormBuilder);
  toast = inject(ToastComponent);


  forgotPasswordForm = this.createForgotPasswordForm();
  setClassInvalid = setClassInvalid;

  createForgotPasswordForm(): UntypedFormGroup {
    return this.formBuilder.group({
      email: ['', Validators.compose([
        Validators.email,
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100)
      ])],
    });
  }

  forgotPassword(): void {
    const email = this.forgotPasswordForm.get('email').value;
    this.userService.forgotPassword({ email })
      .subscribe({
        next: res => this.toast.setMessage('Email sent successfully.', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }
}
